// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom Oplus modal css */
.modal[data-v-7eaff010] {
  color: #929292
}
.oplus-modal[data-v-7eaff010] {
  position: absolute;
  z-index: 10000000;
  display: flex;
}
.modal-header[data-v-7eaff010] {
  padding: 0.6rem 0.8rem;
}
.modal-header-wrapper[data-v-7eaff010] {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-text[data-v-7eaff010] {
  font-size: .9rem;
  display: flex;
}
.modal-container[data-v-7eaff010] {
  padding: 0;
  border-radius: 16px;
  width: fit-content;
  height: fit-content;
  position: relative;
  color: #929292;
}
.modal-body[data-v-7eaff010] {
  padding: 0 0.8rem;
  position: relative;
}
.modal-footer[data-v-7eaff010] {
  padding: 0.8rem;
  position: relative;
}
.modal .close-btn[data-v-7eaff010] {
  display: flex;
  justify-content: end;
  cursor: pointer;
  color: #c9c9c9;
  height: 100%;
}
.modal .close-btn[data-v-7eaff010]:hover {
  color: #bbbdbf
}
.modal-divider[data-v-7eaff010] {
  border: 0;
  width: 100%;
  border-top: 1px solid #cfcfcf;
}
.alert-modal-padding[data-v-7eaff010] {
  padding: 0.2rem 0.8rem 0.8rem 0.8rem;
}

/* Make sure alert modal is always on top */
#alert-confirm-modal[data-v-7eaff010] {
  z-index: 10000002;
}

/* Make sure timecard modal is on top of timepicker modal */
#timecard-vue-modal[data-v-7eaff010] {
  z-index: 10000001;
}
`, "",{"version":3,"sources":["webpack://./src/vue/Modal.vue"],"names":[],"mappings":";AAwEA,2BAA2B;AAC3B;EACE;AACF;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AAEA;EACE;AACF;AAEA;EACE,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;AAEA;EACE,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;AACnB","sourcesContent":["<!-- Base Modal Component -->\n<script setup lang=\"ts\">\nimport { computed } from 'vue';\n\nconst props = withDefaults(defineProps<{\n  modalName?: string;\n  hasTitleDivider?: boolean;\n  hasFooterDivider?: boolean;\n  includeModalFooter?: boolean;\n  includeModalHeader?: boolean;\n}>(), {\n  includeModalFooter: true,\n  includeModalHeader: true,\n});\n\nconst emit = defineEmits<{\n  'close-modal': [];\n  'confirm': [];\n  'cancel': [];\n}>();\n\ndefineSlots<{\n  'header-title'?: () => unknown;\n  'header-icon'?: () => unknown;\n  'content'?: () => unknown;\n  'footer-btn'?: () => unknown;\n}>();\n\nconst alertPadding = computed(() => !props.hasTitleDivider ? 'alert-modal-padding' : '');\n\nfunction closeModal() {\n  emit('close-modal');\n}\n\nfunction confirm() {\n  emit('confirm');\n}\n\nfunction cancel() {\n  emit('cancel');\n}\n\ndefineExpose({ closeModal, confirm, cancel });\n</script>\n<template>\n  <div :id=\"modalName\" class=\"oplus-modal modal active\">\n    <div class=\"modal-overlay\" aria-label=\"Close\" @click=\"closeModal()\"></div>\n    <div class=\"modal-container\" :class=\"alertPadding\">\n      <div v-if=\"includeModalHeader\" class=\"modal-header\">\n        <div class=\"modal-header-wrapper\">\n          <span class=\"header-text\">\n            <slot name=\"header-title\"></slot>\n          </span>\n          <span class=\"close-btn\" aria-label=\"Close\" @click=\"closeModal()\">\n            <i class=\"zmdi zmdi-close zmdi-hc-lg\"></i>\n          </span>\n        </div>\n        <slot name=\"header-icon\"></slot>\n      </div>\n      <div v-if=\"hasTitleDivider\" class=\"modal-divider\"></div>\n      <div class=\"modal-body\">\n        <slot name=\"content\"></slot>\n      </div>\n      <div v-if=\"hasFooterDivider\" class=\"modal-divider\"></div>\n      <div v-if=\"includeModalFooter\" class=\"modal-footer\">\n        <slot name=\"footer-btn\"></slot>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n/* Custom Oplus modal css */\n.modal {\n  color: #929292\n}\n\n.oplus-modal {\n  position: absolute;\n  z-index: 10000000;\n  display: flex;\n}\n\n.modal-header {\n  padding: 0.6rem 0.8rem;\n}\n\n.modal-header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-text {\n  font-size: .9rem;\n  display: flex;\n}\n\n.modal-container {\n  padding: 0;\n  border-radius: 16px;\n  width: fit-content;\n  height: fit-content;\n  position: relative;\n  color: #929292;\n}\n\n.modal-body {\n  padding: 0 0.8rem;\n  position: relative;\n}\n\n.modal-footer {\n  padding: 0.8rem;\n  position: relative;\n}\n\n.modal .close-btn {\n  display: flex;\n  justify-content: end;\n  cursor: pointer;\n  color: #c9c9c9;\n  height: 100%;\n}\n\n.modal .close-btn:hover {\n  color: #bbbdbf\n}\n\n.modal-divider {\n  border: 0;\n  width: 100%;\n  border-top: 1px solid #cfcfcf;\n}\n\n.alert-modal-padding {\n  padding: 0.2rem 0.8rem 0.8rem 0.8rem;\n}\n\n/* Make sure alert modal is always on top */\n#alert-confirm-modal {\n  z-index: 10000002;\n}\n\n/* Make sure timecard modal is on top of timepicker modal */\n#timecard-vue-modal {\n  z-index: 10000001;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
